import { TFunction } from "i18next";
import { BeatLoader } from "react-spinners";

export default function BigLoader({
  t,
}: {
  t: TFunction<"common", undefined>;
}) {
  return (
    <div className="loaderContainer">
      <BeatLoader size={50} color="#0C2658" />
      <h1>{t("Loading...")}</h1>
    </div>
  );
}
